<div class="modal">
  <div class="modal-panel">
    <p class="error-dialog-box-title popup-title">
      {{ 'exit.exit-title' | translate }}
    </p>
    <span id="exitDescription"  class="error-dialog-box-message">
      {{ 'exit.exit-message' | translate }}
    </span>
    <div class="error-dialog-box-buttons exit-box horizontal-focusable-container" data-blocked>
      <button (click)="ok()" class="primary-button focusable-element mr-2" type="button"
        aria-labelledby="exitDescription yesBtnDescription" (focusout)="onButtonFocus()">
        <span id="yesBtnDescription">
          {{ 'exit.yes' | translate }}
        </span>
      </button>
      <button (click)="cancel()" class="primary-button back-btn focusable-element" type="button"
        aria-labelledby="exitDescription noBtnDescription" (focusout)="onButtonFocus()">
        <span id="noBtnDescription">
          {{ 'exit.no' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>